import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { useSearchParams } from 'react-router-dom'
import { Award, PhoneOutgoing, UploadCloud, UserCheck } from 'react-feather'
import { MetricCards, Card } from '../../../components/MetricCards'
import { t } from 'i18next'

export default function CampaignMetrics({ campaign, filterAction }) {
	const [searchParams] = useSearchParams()
	const [activeMetric, setActiveMetric] = useState(null)

	useEffect(() => {
		const activeFilter = metrics.find((metric) => metric.query === searchParams.get('lead_status'))
		setActiveMetric(activeFilter?.key || null)
	}, [searchParams])

	const metrics = [
		{
			key: 'total_leads',
			title: t('metric_label.total_leads'),
			value: campaign?.total_leads || '-',
			query: null,
			Icon: (props) => <UploadCloud {...props} />,
		},
		{
			key: 'total_calls',
			title: t('metric_label.total_calls'),
			value: campaign?.total_calls || '-',
			query: 'Called',
			Icon: (props) => <PhoneOutgoing {...props} />,
		},
		{
			key: 'total_calls_answered',
			title: t('metric_label.total_calls_answered'),
			value: campaign?.total_calls_answered || '-',
			query: 'Called - Human Answered',
			Icon: (props) => <UserCheck {...props} />,
		},
		{
			key: 'total_callback_requests',
			title: t('metric_label.total_callback_requests'),
			value: campaign?.total_callback_requests || '-',
			query: 'Callback Requested',
			Icon: (props) => <Award {...props} />,
		},
	]

	const handleOnClick = (metric) => {
		const payload = metric.query ? { lead_status: metric.query } : {}
		return filterAction(payload)
	}

	return (
		<MetricCards>
			{metrics.map((metric) => (
				<Card
					activeMetric={activeMetric === metric.key}
					metric={metric}
					handleOnClick={handleOnClick}
					sx={{ cursor: 'pointer', paddingLeft: '10px!important' }}
				/>
			))}
		</MetricCards>
	)
}
